
/**
 * @typedef {{selectItemIndex: number, checked: boolean}} Ref
 * @typedef {{toast_not_check_terms: string, toast_not_select_plan: string}} JsonData
 */

if (!customElements.get('recharge-4g')) {
  class Recharge4g extends HTMLElement {
    /** ICCID */
    iccid = '';
    /** APP 用户 ID */
    appUserId = '';
    /** 设备 ID */
    did = '';
    /**
     * 代理源
     * */
    #refOrigin = {
      selectItemIndex: -1,
      checked: false,
    };
    /**
     * @type Ref
     */
    ref = this.#refOrigin;
    #onClickProductItem;
    #onChangeCheckbox;
    #onClickSubmit;

    constructor() {
      super();
      this.init();
      this.attachEvents();
    }

    connectedCallback() {
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    init() {
      // 从 URL 获取 ICCID 和 APP 用户 ID
      this.iccid = new URL(window.location.href).searchParams.get('iccid') || localStorage.getItem('recharge_iccid');
      localStorage.setItem('recharge_iccid', this.iccid);
      this.appUserId = new URL(window.location.href).searchParams.get('app_user_id') || localStorage.getItem('recharge_app_user_id');
      localStorage.setItem('recharge_app_user_id', this.appUserId);
      this.did = new URL(window.location.href).searchParams.get('did') || localStorage.getItem('recharge_did');
      localStorage.setItem('recharge_did', this.did);

      this.elements = {
        scriptJson: this.querySelector('[data-recharge-4g-json]'),
        iccidElement: this.querySelector('[data-iccid]'),
        productItems: this.querySelectorAll('[data-product-item]'),
        checkbox: this.querySelector('[data-notice-checkbox]'),
        submitButton: this.querySelector('[data-submit-button]'),
        finalPrice: this.querySelector('[data-final-price]'),
        /** @type {SimpleToast} */
        toast: this.querySelector('simple-toast'),
      }

      // 更新数据
      this.elements.iccidElement.innerHTML = this.iccid;
      this.#refOrigin.checked = this.elements.checkbox.checked;

      // 整理产品数据
      this.data = {
        products: [...this.elements.productItems].map((item) => ({
          index: Number(item.getAttribute('data-index')),
          variantId: item.getAttribute('data-variant-id'),
          variantPrice: Number(item.getAttribute('data-variant-price')),
        })),
        /** @type {JsonData} */
        json: JSON.parse(this.elements.scriptJson.innerHTML),
      }

      // 代理
      const proxyHander = {
        get(target, key) {
          return target[key];
        },
        set: (target, property, value) => {
          target[property] = value;
          this.render(target, property, value);
          return true;
        },
      };
      this.ref = new Proxy(this.#refOrigin, proxyHander);
      this.#onClickProductItem = this.onClickProductItem.bind(this);
      this.#onChangeCheckbox = this.onChangeCheckbox.bind(this);
      this.#onClickSubmit = this.onClickSubmit.bind(this);

      this.render(this.#refOrigin);
    }

    attachEvents() {
      for (const item of this.elements.productItems) {
        item.addEventListener('click', this.#onClickProductItem);
      }
      this.elements.checkbox.addEventListener('change', this.#onChangeCheckbox);
      this.elements.submitButton.addEventListener('click', this.#onClickSubmit);
    }

    detachEvents() {
      for (const item of this.elements.productItems) {
        item.removeEventListener('click', this.#onClickProductItem);
      }
      this.elements.checkbox.removeEventListener('change', this.#onChangeCheckbox);
      this.elements.submitButton.removeEventListener('click', this.#onClickSubmit);
    }

    /** 
     * 渲染
     * @param {Ref} target 
     * @param {string} property 
     * @param {unknown} value 
     */
    render(target, property, value) {
      if (target.selectItemIndex == undefined || target.selectItemIndex < 0) {
        // this.querySelector('[data-product-item].active').classList.remove('active');
      } else {
        this.querySelector('[data-product-item].active')?.classList.remove('active');
        this.elements.productItems[target.selectItemIndex].classList.add('active');
      }
      if (target.checked && this.ref.selectItemIndex > -1) {
        this.elements.submitButton.classList.remove('disabled');
      } else {
        this.elements.submitButton.classList.add('disabled');
      }

      const productItem = this.ref.selectItemIndex > -1 ? this.data.products[this.ref.selectItemIndex] : undefined;
      if (productItem) {
        this.elements.finalPrice.innerHTML = theme.Currency.formatMoney(productItem.variantPrice, window.theme.strings.moneyFormat);
      }
    }

    /**
     * 选择产品
     * @param {MouseEvent} e 
     */
    onClickProductItem(e) {
      /**
       * @type {HTMLElement}
       */
      const target = e.currentTarget;
      const index = Number(target.getAttribute('data-index'));
      this.ref.selectItemIndex = index;
    }

    /**
     * 勾选条款
     * @param {InputEvent} e 
     */
    onChangeCheckbox(e) {
      console.log(e)
      /**
       * @type {HTMLInputElement}
       */
      const target = e.target;
      this.ref.checked = target.checked;
    }

    /**
     * 提交下单
     * @param {MouseEvent} e 
     */
    onClickSubmit(e) {
      /**
       * @type {HTMLElement}
       */
      // const target = e.target; 
      if (this.ref.selectItemIndex < 0 == undefined || this.ref.selectItemIndex < 0) {
        this.elements.toast.show(this.data.json.toast_not_select_plan);
        return;
      }

      if (!this.ref.checked) {
        this.elements.toast.show(this.data.json.toast_not_check_terms);
        return;
      }

      this.elements.submitButton.classList.add('loading');

      const productItem = this.data.products[this.ref.selectItemIndex];

      const variantId = productItem.variantId;
      const quantity = 1;
      const appUserId = this.appUserId;
      const url = `${window.theme.routes.cart_url}/${variantId}:${quantity}?attributes[app_user_id]=${appUserId}&attributes[iccid]=${this.iccid}&attributes[did]=${this.did}`;

      window.location.href = url;
    }
  }
  customElements.define('recharge-4g', Recharge4g);
}

class SimpleToast extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #333;
          color: white;
          padding: 10px 20px;
          border-radius: 4px;
          z-index: 10001;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
          pointer-events: none;
        }
        :host(.show) {
          opacity: 1;
          visibility: visible;
        }
      </style>
      <slot></slot>
    `;
  }

  show(message) {
    if (message != undefined) {
      this.textContent = message;
    }
    this.classList.add('show');
    setTimeout(() => this.classList.remove('show'), 3200);
  }
}

customElements.define('simple-toast', SimpleToast);
